// Lecturas que se pisan (el chat, el seguimiento de "publicando"): cada una lleva su número y se muestra si es más
// nueva que la última mostrada. Una vieja que llega tarde no pisa a una más nueva, y si las lecturas tardan más que el
// intervalo del seguimiento igual se van mostrando (review Greptile #160, dos vueltas).
export function lecturasEnOrden() {
  let pedidas = 0;
  let mostrada = 0;
  return {
    /** Una lectura nueva: su número. */
    empezar: () => ++pedidas,
    /** ¿Se muestra lo que trajo la lectura `n`? Si sí, queda como la última mostrada. */
    mostrar: (n: number) => {
      if (n < mostrada) return false;
      mostrada = n;
      return true;
    },
    /** ¿`n` sigue siendo la última mostrada? (para lo que se completa después, como los comentarios). */
    esLaMostrada: (n: number) => n === mostrada,
  };
}
